


























































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  PROFILE_USER_SIDEBAR,
  PROFILE_SIDEBAR_OPTIONS,
} from "@/resources/constants/sidebarMenu";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import ProfileGeneralComponent from "@/app/components/profile/components/general.component.vue";
import ProfileSecurityComponent from "@/app/components/profile/components/security.component.vue";
import ProfileSocialComponent from "@/app/components/profile/components/social.component.vue";
import ProfileCvComponent from "@/app/components/profile/components/cv.component.vue";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import ErrorController from "@/resources/mixins/errorController/errorController";
import ChangeAvatarComponent from "@/app/components/profile/components/changeAvatar.component.vue";
import ChangePetComponent from "@/app/components/profile/components/changePet.component.vue";
import UserLogsComponent from "./components/userLogs.component.vue";
import VideoAudioComponet from "./components/videoAudio.component.vue";
import { i18n } from "@/resources/locales";
import ProfileCurriculumComponent from "@/app/components/profile/components/curriculum.component.vue";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "profile-component",
  components: {
    ChangeAvatarComponent,
    ProfileSocialComponent,
    ProfileSecurityComponent,
    ProfileGeneralComponent,
    ProfileCvComponent,
    UserLogsComponent,
    ChangePetComponent,
    VideoAudioComponet,
    ProfileCurriculumComponent,
  },
})
export default class ProfileComponent extends mixins(
  UserValidator,
  ErrorController,
  Plans
) {
  PLAN = PLAN;
  @Validate({ required })
  password = "";
  hasVisiblePassword = false;
  loading = false;
  noData = false;
  menuActive = PROFILE_SIDEBAR_OPTIONS.GENERAL;
  sidebarMenu = PROFILE_USER_SIDEBAR;
  PROFILE_SIDEBAR_OPTIONS = PROFILE_SIDEBAR_OPTIONS;
  city = false;
  showConfirmDeleteDialog = false;
  isLocked = false;
  invite = false;
  isTeams = false;
  get active() {
    let openProfileSocial =
      this.$store.getters["FloatMenuStore/getOpenProfileSocial"];
    if (openProfileSocial) this.menuActive = PROFILE_SIDEBAR_OPTIONS.SOCIAL;
    return (
      this.$store.getters["FloatMenuStore/getOpenProfile"] && !this.onBoarding()
    );
  }
  set active(e) {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", e);
    this.$store.dispatch("FloatMenuStore/setOpenProfileSocialAction", false);
  }
  closeDialog() {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", false);
  }
  logOut(): void {
    this.$store.dispatch("AuthStore/logOutAction");
  }
  get user(): any {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  onBoarding() {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  async mounted() {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
    this.loading = true;
    await this.$store.dispatch("UserStore/getUserAction", {
      callback: async () => {
        this.loading = false;
        this.noData = true;
      },
    });
    if (this.city)
      for (let index = 0; index < this.sidebarMenu.length; index++) {
        const element = this.sidebarMenu[index];
        if (element.id === PROFILE_SIDEBAR_OPTIONS.LOGS) {
          this.sidebarMenu.splice(index, 1);
        }
      }
    if (this.city) {
      this.$store.dispatch("UserStore/getUserAction", {
        callback: async (data) => {
          this.invite = data.isGuest;
        },
      });
    } else {
      const user = this.$store.getters["UserStore/getSpaceUser"];
      this.invite = user.superSpaceUser.user.isGuest;
    }
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
    /// DELETE SECURITY IS TEAMS
    for (let index = 0; index < this.sidebarMenu.length; index++) {
      const element = this.sidebarMenu[index];
      if (this.isTeams && element.id === PROFILE_SIDEBAR_OPTIONS.SECURITY) {
        this.sidebarMenu.splice(index, 1);
      }
    }
  }
  async deleteUser(): Promise<void> {
    if (this.city) {
      this.$store.dispatch("UserStore/getUserAction", {
        callback: async (data) => {
          await this.$store.dispatch("UserStore/deleteUserAction", {
            userId: data.id,
            password: this.password,
            callback: async (response) => {
              if (response.data.status == "OK")
                this.$router.push({ name: "good-bye-view" });
              else {
                this.onError(
                  "",
                  i18n.t("notifications.errorMessages.invalidPassword")
                );
              }
            },
            callbackError: async (error) => {
              this.onError(
                this.$i18n.t("notifications.titles.error"),
                this.$i18n.t("notifications.genericError.genericErrorRetry"),
                "none"
              );
            },
          });
        },
      });
    } else {
      const user = this.$store.getters["UserStore/getSpaceUser"];
      await this.$store.dispatch("UserStore/deleteUserAction", {
        userId: user.superSpaceUser.user.id,
        password: this.password,
        callback: async (response) => {
          if (response.data.status == "OK")
            this.$router.push({ name: "good-bye-view" });
          else
            this.onError(
              "",
              i18n.t("notifications.errorMessages.invalidPassword")
            );
        },
        callbackError: async (error) => {
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t("notifications.genericError.genericErrorRetry"),
            "none"
          );
        },
      });
    }
  }
}
